module.exports = {"region":"us-east-1","userPool":"us-east-1_Z11CUpkSe","identityPool":"us-east-1:e348773b-ff2a-4f37-9fe1-c0424792f020","clientId":"4dqoa9dnd8j9hv6ho6ic1h9u3k"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 930
// module chunks = 0